import Popup from "./Popup";
import PopupClose from "./popup-close";
import PopupBack from "./popup-back";
import QuestionBox from "./question-box";

export default Popup;

export { PopupClose, PopupBack, QuestionBox };
